// extracted by mini-css-extract-plugin
export var boldText = "_7k-4";
export var checkboxContainer = "_7k-6";
export var closeIcon = "_7k-i";
export var container = "_7k-0";
export var drawer = "_7k-8";
export var drawerContent = "_7k-9";
export var extraSmallText = "_7k-5";
export var fulfillmentGroupTable = "_7k-e";
export var largeText = "_7k-3";
export var loadingSpinnerContainer = "_7k-j";
export var mediumText = "_7k-2";
export var narrow = "_7k-f";
export var notificationLink = "_7k-l";
export var packageCheckIconContainer = "_7k-7";
export var slideoutHeaderActions = "_7k-g";
export var slideoutHeaderActionsShifted = "_7k-h";
export var slideoutHeaderContainer = "_7k-a";
export var slideoutModal = "_7k-c";
export var stickyHeaderWrapper = "_7k-b";
export var table = "_7k-k";
export var tableContainer = "_7k-d";
export var tertiaryText = "_7k-1";